exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tip[data-v-98ac867a] {\n    margin-top: 5px;\n    color: #909399;\n    font-size: 12px;\n    line-height: 20px;\n}\n", ""]);

// exports
